import { render, staticRenderFns } from "./stacked-spreads-input.vue?vue&type=template&id=23702c59&"
import script from "./stacked-spreads-input.vue?vue&type=script&lang=js&"
export * from "./stacked-spreads-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports